module.exports = __webpack_public_path__ + "img/Ad_Delight.12bfede6.png";